import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class DataService {

    public setPostData(data: any) {
        sessionStorage.setItem("postdata", JSON.stringify(data));
    }

    public getPostData(): any {
        return sessionStorage.getItem("postdata");
    }

    cmdClick = new EventEmitter<any>();
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/data.service.ts